module.exports = __webpack_public_path__ + "static/img/guide-38.7494b8f4.png";